module.exports = __webpack_public_path__ + "media/images/icons/flags/BL-4b086699ed96eddca06bfce6eb71b430.svg";